import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import api from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { toast } from '../hooks/use-toast';

const AuthCallbackPage = () => {
  const navigate = useNavigate();
  const { setTokenAndUser } = useAuth();
  const [status, setStatus] = useState('Verificando sesión...');

  useEffect(() => {
    const handle = async () => {
      const hash = window.location.hash || '';
      const params = new URLSearchParams(hash.replace(/^#/, ''));
      const sessionId = params.get('session_id');
      if (!sessionId) {
        setStatus('Sin sesión de Google. Redirigiendo...');
        setTimeout(() => navigate('/'), 1500);
        return;
      }
      try {
        const r = await api.post('/auth/emergent-session', { session_id: sessionId });
        setTokenAndUser(r.data.token, r.data.user);
        toast({ title: '¡Bienvenido!', description: r.data.user.name || r.data.user.email });
        window.history.replaceState({}, document.title, '/');
        navigate('/');
      } catch (e) {
        setStatus('No se pudo iniciar sesión');
        toast({ title: 'Error', description: 'Sesión de Google inválida' });
        setTimeout(() => navigate('/'), 2000);
      }
    };
    handle();
  }, [navigate, setTokenAndUser]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-white">
      <Loader2 className="w-8 h-8 animate-spin text-orange-500" />
      <p className="mt-4 text-white/70">{status}</p>
    </div>
  );
};

export default AuthCallbackPage;
